import DateUtils from '@/core/utils/date-utils'

export const LoginUtils = {

  isUsuarioLogado: () => {
    const token = localStorage.getItem('token')

    if (token) {
      const usuario = JSON.parse(localStorage.getItem('usuario'))

      if (usuario && usuario.dataUltimoAcessoPlataforma) {
        const isTempoSessaoValida = DateUtils.create(usuario.dataUltimoAcessoPlataforma).add(1, 'days').isSameOrAfter(new Date())

        if (isTempoSessaoValida) {
          const usuario = JSON.parse(localStorage.getItem('usuario'))
          usuario.dataUltimoAcessoPlataforma = new Date()

          localStorage.setItem('usuario', JSON.stringify(usuario))
        } else {
          localStorage.setItem('motivoSessaoLogoutForcado', true)
          localStorage.removeItem('motivoDispositivosLogoutForcado')
          localStorage.removeItem('token')
          localStorage.removeItem('usuario')
        }

        return isTempoSessaoValida
      }

      return false
    }

    return token
  },

  getToken: () => localStorage.getItem('token'),

  getUsuario: () => JSON.parse(localStorage.getItem('usuario')),

  getUuid: () => JSON.parse(localStorage.getItem('uuidLs')),

  setUsuario: usuario => {
    usuario.dataUltimoAcessoPlataforma = new Date()
    localStorage.setItem('usuario', JSON.stringify(usuario))
    localStorage.removeItem('motivoDispositivosLogoutForcado')
    localStorage.removeItem('motivoSessaoLogoutForcado')
  },

  setToken: token => {
    localStorage.setItem('token', token)
  },

  logout: () => {
    localStorage.removeItem('token')
    localStorage.removeItem('usuario')
  },

  setMotivoSessaoLogoutForcado: () => {
    localStorage.setItem('motivoSessaoLogoutForcado', true)
  },

  getMotivoSessaoLogoutForcado: () => localStorage.getItem('motivoSessaoLogoutForcado'),

  removeMotivoSessaoLogoutForcado: () => {
    localStorage.removeItem('motivoSessaoLogoutForcado')
  },

  setMotivoDispositivosLogoutForcado: () => {
    localStorage.setItem('motivoDispositivosLogoutForcado', true)
  },

  getMotivoDispositivosLogoutForcado: () => localStorage.getItem('motivoDispositivosLogoutForcado'),

  removeMotivoDispositivosLogoutForcado: () => {
    localStorage.removeItem('motivoDispositivosLogoutForcado')
  }
}

export default LoginUtils
